import { render, staticRenderFns } from "./EventBindSuccPopup.vue?vue&type=template&id=70c81692&scoped=true&"
import script from "./EventBindSuccPopup.vue?vue&type=script&lang=js&"
export * from "./EventBindSuccPopup.vue?vue&type=script&lang=js&"
import style0 from "./EventBindSuccPopup.vue?vue&type=style&index=0&id=70c81692&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c81692",
  null
  
)

export default component.exports